<mat-card class="sunset-banner" style="margin-bottom: 16px; border-left: 4px solid #f44336; background-color: #ff000022">
  <mat-card-header>
    <div mat-card-avatar>
      <mat-icon >info</mat-icon>
    </div>
    <mat-card-title>Script Submissions are dead</mat-card-title>
    <mat-card-subtitle>Rest in peace, we'll miss you :c</mat-card-subtitle>
  </mat-card-header>
  <mat-card-content>
  </mat-card-content>

</mat-card>